import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { AssetProduct } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-entity';

export class AssetProductRequest extends BaseRequest{
  assetProduct : AssetProduct;
  constructor(userInfo){    
    super(userInfo);
    this.assetProduct = new AssetProduct();
  }
}